import { gql } from "@apollo/client";
import { CONTENT_NODE_FIELDS } from "@/app/graphql/fragments/contentNodeFields";

export const FETCH_CONTEXT_FOR_CHAT = gql`
    ${CONTENT_NODE_FIELDS}
    query ContextForChat($chatId: ID!) {
        contextForChat(chatId: $chatId) {
            id
            graphEnabled
            companyContextEnabled
            gptOnlyEnabled
            isLocked
            sizeInPages
            totalAllowedPages
            sizeInTokens
            contentNodes {
                ...ContentNodeFields
            }
            attachments {
                id
                messageId
                fileName
                tokens
                fileSize
                pages
            }
        }
    }
`;
